import { LaunchHelpCode } from "./LaunchHelpCode";

export function LaunchHelp(helpButton) {
  /*
		case "Help":
			LaunchHelpLookup("main_help");
			break;{*/
  var helpCode = helpButton.GetHelpCode();
  var isADPEdition = false;
  if (isADPEdition) {
    var canvas = document.getElementById("basecanvas");
    var event = new CustomEvent("helpEvent", { detail: helpCode });
    canvas.dispatchEvent(event);
  } else {
    LaunchHelpCode(helpCode);
  }
}
